import angular from 'angular';
import 'invision-core';
import ChangeStepPopupComponent from './change.step.popup.component';
export default angular.module('inv.customer.treatmentDetails.changeStepPopup', ['invision.core.components']).component('changeStepPopup', ChangeStepPopupComponent).name;